// @ts-check
// Campo ARRAY (lista de textos, doc 04): regras puras do editor da tabela e do registro.

/**
 * @param {unknown} value
 * @returns {string[]}
 */
export function toArrayItems(value) {
  return Array.isArray(value) ? value.map((item) => String(item ?? '')).filter((item) => item !== '') : [];
}

/**
 * Acrescenta um item: sem espaços nas pontas, sem vazio e sem repetir.
 * @param {string[]} items @param {string} text
 */
export function addArrayItem(items, text) {
  const item = String(text ?? '').trim();
  if (!item || items.includes(item)) return items;
  return [...items, item];
}

/**
 * Troca o texto de um item; vazio remove e repetido é ignorado.
 * @param {string[]} items @param {number} index @param {string} text
 */
export function replaceArrayItem(items, index, text) {
  const item = String(text ?? '').trim();
  if (!item) return removeArrayItem(items, index);
  if (items.some((existing, position) => existing === item && position !== index)) return items;
  return items.map((existing, position) => (position === index ? item : existing));
}

/** @param {string[]} items @param {number} index */
export function removeArrayItem(items, index) {
  return items.filter((_item, position) => position !== index);
}

/**
 * Valor gravado: lista vazia vira null, como os outros campos sem valor, salvo em campo obrigatório.
 * @param {string[]} items @param {{ isNullable?: boolean | null }} field
 */
export function toArrayFieldValue(items, field) {
  return items.length > 0 || field.isNullable === false ? items : null;
}
